import React from "react";
import { useTranslation } from "react-i18next";

import { HTTPMethods } from "../../../../yoello-lib/modules/API/API";
import DraggableList, { ICard } from "../../../../yoello-lib/modules/components/draggable-list";
import ListLoading from "../../../util/Loading";
import NotFound from "../../../../yoello-lib/modules/components/UI/NotFound/NotFound";

interface IProductListViewProps<T> {
    isLoading: boolean;
    productList: T[];
    onItemSelection: (product: T) => void;
    parentEntry: any[];
    fieldList: any[];
    sortAPICall: any;
    listClassName: string;
    emptyEntryText: string;
    emptyEntryTextInfo: string;
    emptyListText: string;
    emptyListTextInfo: string;
    merchantType?: string | null;
    onSortedItem?: (product: string[]) => void;
    dataComponentName?: string;
}

export function ProductListView<T>({
    isLoading,
    productList,
    onItemSelection,
    parentEntry,
    sortAPICall,
    fieldList,
    listClassName,
    emptyEntryText,
    emptyEntryTextInfo,
    emptyListText,
    emptyListTextInfo,
    onSortedItem,
    merchantType,
    dataComponentName
}: IProductListViewProps<T>) {
    const { t } = useTranslation();

    if (isLoading) {
        return <ListLoading />;
    }
    if (productList.length > 0) {
        return <DraggableList
            nameFieldIndex={1}
            className={listClassName}
            list={productList}
            fields={fieldList}
            id={'productlist-' + listClassName}
            onClick={(data: ICard) => {
                onItemSelection(data as T);
            }}
            onDrop={(data) => sortAPICall ?
                sortAPICall(HTTPMethods.PATCH, {
                    body: data.map((item) => item.id)
                }).then(() => {
                    if (onSortedItem) onSortedItem(data.map((item) => item.id));
                })
                : null
            }
            dataComponentName={dataComponentName}

        />
    } else {
        const renderNotFound = () => parentEntry.length ?
            <NotFound
                title={t(emptyEntryText)}
                description={merchantType ? t(emptyEntryTextInfo, { merchant: merchantType }) : t(emptyEntryTextInfo)}
            />
            :
            <NotFound
                title={t(emptyListText)}
                description={merchantType ? t(emptyListTextInfo, { merchant: merchantType }) : t(emptyListTextInfo)}
            />;

        return <div style={{
            marginTop: "5rem",
        }}>
            {renderNotFound()}
        </div>;
    }
}